<div class="container-fluid m-0 p-0" *ngIf="checkDataExist()">
    <div class="row">
        <div class="col-12 mt-4">
            <div class="border-bottom font-16 mb-3 text-bold">{{ "TAB_GENERAL_DATA_2" | translate | titlecase }}</div>
        </div>
        <div class="col-12">
            <div class="row m-0 p-3 bg-light-grey">


                <div class="col-md-6 mb-2" *ngFor="let question of questionData">
                    <label class="font-bold">
                        {{
                        (globals.lang == 'ar')? question.questionDescAr : question.questionDescEn
                        }}</label>
                    <p class="cand-answer">{{question.answer }}</p>
                </div>

            </div>
        </div>

    </div>
</div>
<app-loader [show]="!checkDataExist()"></app-loader>